import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "shtrix-code" }

import QRCodeVue3 from "qrcode-vue3";
import { defineProps } from "vue/dist/vue";
import { Esim } from "@/stores/esim";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivationQr',
  props: {
  esim: Esim,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("figure", null, [
      _createVNode(_unref(QRCodeVue3), {
        value: `LPA:1$${__props.esim?.smdpAddress}$${__props.esim?.matchingId}`,
        qrOptions: {
          typeNumber: '0',
          mode: 'Byte',
          errorCorrectionLevel: 'Q',
        },
        imageOptions: {
          hideBackgroundDots: true,
          imageSize: 0.4,
          margin: 0,
        },
        dotsOptions: { type: 'square', color: '#05004d' },
        cornersSquareOptions: {
          type: 'square',
          color: '#0e013c',
        },
        image: require('@/assets/images/qr-logo.svg')
      }, null, 8, ["value", "image"])
    ])
  ]))
}
}

})